// extracted by mini-css-extract-plugin
export default {"menuBlock":"SF-z","title":"TF-z","nav":"UF-z","flexCell":"VF-z","facetLink":"WF-z"};